import React, { useEffect, useState } from "react";
import { useParams, useNavigate } from "react-router-dom";
import axios from "axios";
import { ootImg } from "../imgUrl";

// Main gallery image shows large; thumbnails are tiny. Size each accordingly.
const resolveImg = (img) => ootImg(img, 900);
const resolveThumb = (img) => ootImg(img, 160);

const Product = () => {
  const { id } = useParams();
  const navigate = useNavigate();
  const [selectedImage, setSelectedImage] = useState(null);
  const [imgBroken, setImgBroken] = useState(false);
  const [qty, setQty] = useState(1);
  const [added, setAdded] = useState(false);
  const [wished, setWished] = useState(false);
  const [sel, setSel] = useState({});
  const [formData, setFormData] = useState({
    id: -1, name: "", images: [], description: "", barcode: "",
    type_id: "", category_id: "", category: "", price: "", price_before_discount: 0, cost: "", details: {},
  });

  useEffect(() => { getData(); window.scrollTo(0, 0); /* eslint-disable-next-line */ }, [id]);

  const getData = () => {
    if (!id) return;
    axios.get(`${process.env.REACT_APP_API_BASE_URL}/Public/getItemById/${id}`)
      .then((res) => {
        const d = res.data;
        if (!d) return;
        setFormData({
          id: d.id || -1, name: d.name || "", images: d.images || [], description: d.description || "",
          barcode: d.barcode || "", type_id: d.type_id || "", category_id: d.category_id || "",
          category: d.category || "", price: d.price || "", price_before_discount: d.price_before_discount || 0, cost: d.cost || "",
          details: d.details && !Array.isArray(d.details) ? d.details : {},
        });
        setSel({});
        setSelectedImage(d.images && d.images.length ? resolveImg(d.images[0].image) : null);
        setImgBroken(false);
      })
      .catch((e) => console.log(e));
  };

  const handleAddToCart = () => {
    const price = parseFloat(formData.price) || 0;
    const stored = JSON.parse(localStorage.getItem("cart")) || [];
    const idx = stored.findIndex((it) => it.id === formData.id);
    if (idx !== -1) {
      stored[idx].quantity += qty;
      stored[idx].totalPrice = stored[idx].quantity * price;
    } else {
      stored.push({
        id: formData.id, name: formData.name, description: formData.description, price,
        images: formData.images || [], quantity: qty, totalPrice: price * qty, selectedDetails: [],
      });
    }
    localStorage.setItem("cart", JSON.stringify(stored));
    setAdded(true);
    setTimeout(() => setAdded(false), 1800);
  };

  const handleAddToWish = () => {
    const wish = JSON.parse(localStorage.getItem("Wishcart")) || [];
    if (!wish.find((w) => w.id === formData.id)) {
      wish.push({ id: formData.id, name: formData.name, description: formData.description, price: parseFloat(formData.price) || 0, images: formData.images || [] });
      localStorage.setItem("Wishcart", JSON.stringify(wish));
    }
    setWished(true);
  };

  const price = Number(formData.price || 0);
  const was = Number(formData.price_before_discount || 0);
  const hasDiscount = was > price;

  return (
    <>
      <div className="oot-crumb">
        <a onClick={() => navigate("/")}>Home</a> / <a onClick={() => navigate("/Category")}>Shop</a> / {formData.name}
      </div>
      <div className="oot-pdp">
        <div>
          <div className="oot-gallery-main">
            {selectedImage && !imgBroken ? (
              <img src={selectedImage} alt={formData.name} onError={() => setImgBroken(true)} />
            ) : (
              <div className="oot-ph">
                <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.4" strokeLinejoin="round">
                  <path d="M3 7l9-4 9 4v10l-9 4-9-4z" /><path d="M3 7l9 4 9-4M12 11v10" />
                </svg>
                <span>{formData.name}</span>
              </div>
            )}
          </div>
          {formData.images.length > 1 && (
            <div className="oot-thumbs">
              {formData.images.map((el, i) => {
                const full = resolveImg(el.image);   // what the main view shows
                return (
                  <div key={i} className={`oot-thumb${selectedImage === full ? " on" : ""}`}
                    onClick={() => { setSelectedImage(full); setImgBroken(false); }}>
                    <img src={resolveThumb(el.image)} alt="" loading="lazy" />
                  </div>
                );
              })}
            </div>
          )}
        </div>

        <div>
          {formData.category && <div className="oot-pdp-cat">{formData.category}</div>}
          <h1 className="oot-pdp-name">{formData.name}</h1>
          <div className="oot-pdp-price">${price}{hasDiscount && <span className="was">${was}</span>}</div>
          <div className="oot-pdp-stock"><span className="dot" />In stock</div>
          {formData.description && <p className="oot-pdp-desc">{formData.description}</p>}

          {Object.keys(formData.details || {}).map((opt) => (
            <div className="oot-variant" key={opt}>
              <div className="oot-variant-label">{opt}
                {sel[opt] && <span>{(formData.details[opt].find((v) => v.id === sel[opt]) || {}).value}</span>}
              </div>
              <div className="oot-variant-opts">
                {formData.details[opt].map((v) => (
                  <button key={v.id} className={`oot-opt${sel[opt] === v.id ? " on" : ""}`}
                    onClick={() => setSel((s) => ({ ...s, [opt]: v.id }))}>{v.value}</button>
                ))}
              </div>
            </div>
          ))}

          <div className="oot-pdp-actions">
            <div className="oot-qty">
              <button onClick={() => setQty((q) => Math.max(1, q - 1))}>−</button>
              <span>{qty}</span>
              <button onClick={() => setQty((q) => q + 1)}>+</button>
            </div>
            <button className="oot-btn oot-btn-primary oot-btn-lg" onClick={handleAddToCart}>
              {added ? "✓ Added to cart" : "Add to cart"}
            </button>
            <button className="oot-btn oot-btn-ghost oot-btn-lg" onClick={handleAddToWish}>
              {wished ? "♥ Saved" : "♡ Wishlist"}
            </button>
          </div>

          <div className="oot-share">Share:
            <span title="Email"><svg viewBox="0 0 24 24" width="17" height="17" fill="none" stroke="currentColor" strokeWidth="2"><rect x="3" y="5" width="18" height="14" rx="2" /><path d="M3 7l9 6 9-6" /></svg></span>
            <span title="Facebook"><svg viewBox="0 0 24 24" width="17" height="17" fill="currentColor"><path d="M14 9h3V6h-3a4 4 0 0 0-4 4v2H7v3h3v6h3v-6h3l1-3h-4v-2a1 1 0 0 1 1-1z" /></svg></span>
            <span title="Twitter"><svg viewBox="0 0 24 24" width="17" height="17" fill="currentColor"><path d="M22 5.9c-.7.3-1.5.6-2.3.7a4 4 0 0 0 1.8-2.2c-.8.5-1.7.8-2.6 1a4 4 0 0 0-6.9 3.6A11.3 11.3 0 0 1 3.8 4.6a4 4 0 0 0 1.2 5.3c-.6 0-1.2-.2-1.8-.5a4 4 0 0 0 3.2 4 4 4 0 0 1-1.8.1 4 4 0 0 0 3.7 2.8A8 8 0 0 1 2 18.1 11.3 11.3 0 0 0 8.1 20c7.3 0 11.4-6.1 11.4-11.4v-.5c.8-.6 1.4-1.3 2-2.1z" /></svg></span>
          </div>
        </div>
      </div>
    </>
  );
};

export default Product;
